import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2040c0b6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2040c0b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2040c0b6')) {
      api.createRecord('2040c0b6', component.options)
    } else {
      api.reload('2040c0b6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2040c0b6&scoped=true", function () {
      api.rerender('2040c0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/baseConfig/costConfig/index.vue"
export default component.exports